import { abandonOrder, anyWorkflowInProgress, onAnyWorkflowPage } from '@common/utils/workflowUtilities'
import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import { clearOrder, getOrderLineCount, getOrderSelections } from '@vista-digital/occ-domain/src'
import { useEffect } from 'react'
import { navigationService } from '@/content/services/navigation.service'

export const useAbandonOrder = () => {
    const logger = useLogger('useAbandonOrder')

    const currentPage = navigationService.getCurrentPage()
    const currentSubPage = navigationService.getCurrentSubPage()

    useEffect(() => {
        /**
         * This hook exists in both the PageWrapper and SubPageWrapper components, so when it runs from the PageWrapper component
         * it will not have a current sub page. In this case, we want to skip the checks and wait for this hook to fire again from the SubPageWrapper component.
         */
        if (!currentPage) {
            return
        }

        if (navigationService.Pages[currentPage]?.subPages && !currentSubPage) {
            logger.trace(
                'Current page has sub pages but no current sub page found. Skipping checks for current render.',
                { currentPage }
            )
            return
        }

        const anyInProgress = anyWorkflowInProgress()
        const onAnyPage = onAnyWorkflowPage(currentSubPage || currentPage)

        logger.debug('Current or sub page changed, checking if order should be abandoned', {
            currentPage,
            currentSubPage,
            anyInProgress,
            onAnyPage,
        })
        if (onAnyPage) return

        if (anyInProgress) {
            logger.info('Abandoning order due to workflow in progress and not on any workflow page', {
                currentPage,
                currentSubPage,
            })
            void abandonOrder()
        } else if (getOrderLineCount() > 0 || getOrderSelections()?.showtime) {
            logger.info('Clear order selections')
            clearOrder()
        }
    }, [currentPage, currentSubPage, logger])
}
